import { useEffect, useState } from "react"

export function useDebouncedProgress() {
    const [debouncing, setDebouncing] = useState<boolean>(false)
    const [progress, setProgress] = useState<number>(0)
    useEffect(() => {
        if (debouncing) {
            const timer = setInterval(() => {
                setProgress((prevProgress) => (prevProgress >= 100 ? 100 : prevProgress + 4))
            }, 100)
            return () => {
                clearInterval(timer)
            }
        } else {
            setProgress(0)
        }
    }, [debouncing])
    return { debouncing, progress, setDebouncing, setProgress }
}
